import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CardBasic from "../components/CardBasic";
import ModalLoading from "../components/ModalLoading";
import { sheetNotify } from "../utils/Utils";
import CheckImg from "../assets/images/check.png";
import bg from "../assets/images/bg-success.png";
import _ from "lodash";
import ButtonRequire from "../components/Button/ButtonRequire";
import ModalPin from "../components/Modal/ModalPin";
import ModalInformation from "../components/Modal/ModalInformation";
import withAuth from "../components/withAuth";
import { useAuth } from "../components/auth/authContext";
import { requestAuthGet, requestAuthPost } from "../api/authInstance";
import useAPI from "../hooks/useAPI";
import InformationSheet from "../components/Sheet/InformationSheet";
import { ERROR_MESSAGE, sheetMessage } from "../utils/constants";
import CardSection from "../components/Card/CardSection";
import Button from "../components/Button/Button";
import OTPInput from "react-otp-input";
import { Checkbox } from "@nextui-org/react";
import Container from "../components/Container/Container";

const Withdraw = () => {
  const { userData } = useAuth();
  const { state } = useLocation();
  const { saldo } = state ?? {};
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [message, setMessage] = useState({
    title: "",
    message: "",
    type: "",
    isShow: false,
  });
  const [withdrawData, setWithdrawData] = useState(saldo);
  const [pin, setPin] = useState("");
  const [countPinTrial, setCountPinTrial] = useState(0);
  const [showModalPin, setShowModalPin] = useState(false);
  const [showModalInformation, setShowModalInformation] = useState(false);

  const [bankAccount, loadingBankAccount] = useAPI("/bank-account", {
    retailer: userData?.outlet?.retailer?.id,
  });
  const [balance, loadingBalance] = useAPI("/ewallet/balance", {
    retailer: userData?.outlet?.retailer?.id,
  });
  // sheet state
  const [sheetDetail, setSheetDetail] = useState({
    title: "",
    detail: "",
    open: false,
  });

  const ADMIN_FEE = 1400;

  const handleMessageError = (_message) => {
    setMessage({
      message:
        _message ??
        "Sorry you failed to withdraw your balance, please check your balance again.",
      type: "error",
      isShow: true,
    });
    setShowModalLoading(false);
  };

  const GetDataSaldo = async () => {
    try {
      let response = await requestAuthGet("ewallet/balanced");
      const balance = response?.data?.data;
      return {
        ewallet_balance: balance.ewallet ? balance.ewallet : 0,
        deposit_balance: balance.deposit ? balance.deposit : 0,
      };
    } catch (error) {
      console.error(error);
    }
  };

  const WithdrawBalance = async () => {
    try {
      setShowModalLoading(true);
      const pinResponse = await requestAuthPost(
        "dompet-kartini-pin/check-pin",
        {
          userOutlet: userData?.userOutlet,
          pinCode: pin,
        },
      );
      if (pinResponse.error) {
        sheetNotify(sheetMessage(pinResponse), setSheetDetail);
      } else {
        setShowModalPin(false);
        if (!_.isEmpty(pinResponse.data.data)) {
          const withdrawalResponse = await requestAuthPost(
            "transaction/withdrawal/draft",
            {
              retailer: userData?.outlet?.retailer?.id,
              bankAccount: bankAccount[0]?.id,
              nominal: parseInt(withdrawData.nominal),
            },
          );
          console.log(withdrawalResponse);
          if (withdrawalResponse.error) {
            sheetNotify(sheetMessage(withdrawalResponse), setSheetDetail);
          } else {
            sheetNotify(
              {
                title: "Permintaan Withdrawal diterima",
                detail:
                  "Kami telah menerima permintaan withdrawal (penarikan dana) Anda. Proses penarikan dana membutuhkan waktu 2 (dua) hari kerja. Anda dapat memantau prosesnya pada confirmation status withdrawal pada menu E-Wallet. Terima kasih atas partisipasi Anda sebagai Mitra Kartini.",
                icon: "success",
              },
              setSheetDetail,
            );
            setMessage({
              title: "Penarikan dana E-Wallet anda telah berhasil",
              message:
                "Dana akan masuk ke rekening Anda paling lama dalam 2 (dua) hari kerja.",
              type: "success",
              isShow: true,
            });
            setStep(step + 1);
          }
        } else {
          sheetNotify(ERROR_MESSAGE, setSheetDetail);
        }
      }
      setShowModalPin(false);
      setShowModalLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const BannerMessage = () => {
    return (
      <>
        <img src={bg} alt="" className="absolute top-0 -z-50 -mt-16 w-full" />
        <div className="pt-10">
          <div className="flex flex-col items-center justify-center gap-2 px-5 text-center">
            {message.type === "success" && <img src={CheckImg} alt="Success" />}
            <p className="mt-3 text-xl font-semibold">{message.title}</p>
            <span className="text-xs text-monochrome-300">
              {message.message}
            </span>
          </div>
        </div>
      </>
    );
  };

  /* Fungsi */
  function formatRupiah(angka, prefix) {
    angka = typeof angka === "string" ? angka : angka?.toString();
    var number_string = angka?.replace(/[^,\d]/g, "")?.toString(),
      split = number_string?.split(","),
      sisa = split?.length > 0 && split[0].length % 3,
      rupiah = split?.length > 0 && split[0].substr(0, sisa),
      ribuan = split?.length > 0 && split[0].substr(sisa).match(/\d{3}/gi);

    if (ribuan) {
      let separator = sisa ? "." : "";
      rupiah += separator + ribuan.join(".");
    }

    rupiah =
      split?.length > 0 && split[1] != undefined
        ? rupiah + "," + split?.length > 0 && split[1]
        : rupiah;
    return prefix == undefined ? rupiah : rupiah ? "Rp. " + rupiah : "";
  }

  // console.log(
  //   parseInt(withdrawData.nominal) === balance.ewalletBalance,
  //   balance.ewalletBalance,
  // );

  return (
    <>
      <ModalInformation
        showModal={showModalInformation}
        setShowModal={setShowModalInformation}
        type="success"
        title="Permintaan Withdrawal diterima"
        detail="Kami telah menerima permintaan withdrawal (penarikan dana) Anda. Proses penarikan dana membutuhkan waktu 2 (dua) hari kerja. Anda dapat memantau prosesnya pada confirmation status withdrawal pada menu E-Wallet. Terima kasih atas partisipasi Anda sebagai Mitra Kartini."
      />
      <ModalPin
        showModal={showModalPin}
        setShowModal={setShowModalPin}
        pin={pin}
        setPin={setPin}
        functionOnClick={WithdrawBalance}
        message={message}
      />
      <ModalLoading
        showModal={showModalLoading}
        setShowModal={setShowModalLoading}
      />

      <Container>
        {step >= 4 && message.isShow && BannerMessage()}
        {step < 4 && (
          <div className="flex items-center justify-between px-5 pt-5">
            <div>
              {step < 4 && (
                <button
                  className=""
                  onClick={() =>
                    step === 1 ? navigate(-1) : setStep(step - 1)
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              )}
            </div>
            <div className="flex items-center justify-center gap-2">
              <div
                className={`px-1.5 ${
                  step >= 1
                    ? "gradient-bg text-white"
                    : "bg-gray-200 text-gray-500"
                } flex h-7 w-7 items-center justify-center rounded-full text-sm`}
                onClick={() => setStep(1)}
              >
                1
              </div>
              {/* <div
            className={`h-1 w-6 ${
              step >= 1 ? "bg-indigo-500" : "bg-gray-200"
            } `}
          ></div> */}
              {step === 1 ? (
                <p className="bg-gradient-to-r from-blue-600 from-5% via-purple-600 via-50% to-soft-red-500 to-95% bg-clip-text font-semibold text-transparent">
                  Jumlah Penarikan
                </p>
              ) : (
                <p className="text-lg text-monochrome-400">&#9656;</p>
              )}
              <div
                className={`px-1.5 ${
                  step >= 2
                    ? "gradient-bg text-white"
                    : "bg-gray-200 text-gray-500"
                } flex h-7 w-7 items-center justify-center rounded-full text-sm`}
              >
                2
              </div>
              {step === 2 ? (
                <p className="bg-gradient-to-r from-blue-600 from-5% via-purple-600 via-50% to-soft-red-500 to-95% bg-clip-text font-semibold text-transparent">
                  Review Tarik Dana
                </p>
              ) : (
                <p className="text-lg text-monochrome-400">&#9656;</p>
              )}
              <div
                className={`px-1.5 ${
                  step === 3
                    ? "gradient-bg text-white"
                    : "bg-gray-200 text-gray-500"
                } flex h-7 w-7 items-center justify-center rounded-full text-sm`}
              >
                3
              </div>
              {step === 3 && (
                <p className="bg-gradient-to-r from-blue-600 from-5% via-purple-600 via-50% to-soft-red-500 to-95% bg-clip-text font-semibold text-transparent">
                  Konfirmasi PIN
                </p>
              )}
            </div>
          </div>
        )}
        <div className="space-y-5 px-5 py-5">
          {step !== 3 && (
            <CardSection title="Bank Penerima">
              <div className="">
                <div className="space-y-3">
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-700">
                      Bank Name
                    </div>
                    <p className="text-gray-500">
                      {loadingBankAccount ? (
                        <div class="h-5 w-1/2 animate-pulse rounded bg-gray-200"></div>
                      ) : (
                        bankAccount[0]?.bankName ?? "-"
                      )}
                    </p>
                  </div>
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-700">
                      Account Number
                    </div>
                    <p className="text-gray-500">
                      {loadingBankAccount ? (
                        <div class="h-5 w-1/2 animate-pulse rounded bg-gray-200"></div>
                      ) : (
                        bankAccount[0]?.accountNumber ?? "-"
                      )}
                    </p>
                  </div>
                  <div className="text-sm">
                    <div className="mb-1 font-medium text-gray-800">
                      Account Owner Name
                    </div>
                    <p className="text-gray-500">
                      {loadingBankAccount ? (
                        <div class="h-5 w-1/2 animate-pulse rounded bg-gray-200"></div>
                      ) : (
                        bankAccount[0]?.name ?? "-"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </CardSection>
          )}

          {/* step 2 */}
          {step > 1 && step !== 3 && (
            <>
              <CardSection title="Withdraw Details">
                <div className="">
                  <div className="space-y-3">
                    <div className="space-y-2 text-sm">
                      <div className="flex items-center justify-between">
                        <p className="text-gray-500">Total Penarikan</p>
                        <p className="text-gray-500">
                          {formatRupiah(
                            withdrawData.nominal?.toString(),
                            "Rp. ",
                          )}
                        </p>
                      </div>
                      <div className="flex items-center justify-between">
                        <p className="text-gray-500">Biaya Transfer</p>
                        <p className="text-gray-500">
                          - {formatRupiah(ADMIN_FEE?.toString(), "Rp. ")}
                        </p>
                      </div>
                    </div>
                    <hr />
                    <div className="text-sm">
                      <div className="flex items-center justify-between">
                        <div className="font-medium text-soft-red-600">
                          Nilai Transfer
                        </div>
                        <p className="font-semibold text-gray-900">
                          {formatRupiah(
                            (
                              parseInt(withdrawData.nominal) - ADMIN_FEE
                            )?.toString(),
                            "Rp. ",
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </CardSection>
            </>
          )}
          {step === 1 && (
            <CardSection
              title="Enter Amount"
              footer={
                <div>
                  <Checkbox
                    onValueChange={(isSelected) => {
                      setWithdrawData((prevState) => ({
                        ...prevState,
                        nominal: isSelected ? balance?.ewalletBalance : "",
                      }));
                    }}
                    isSelected={
                      parseInt(withdrawData.nominal || 0) ===
                      balance?.ewalletBalance
                    }
                    color="secondary"
                  >
                    Take All Balance
                  </Checkbox>
                </div>
              }
            >
              <div className="text-sm">
                <input
                  name="nominal"
                  placeholder="Rp. 0"
                  className={`form-input mb-0.5 mt-1.5 h-12 w-full font-semibold ${
                    withdrawData.nominal > balance?.ewalletBalance &&
                    "border-2 border-red-500"
                  }`}
                  type="text"
                  value={
                    withdrawData.nominal
                      ? formatRupiah(withdrawData.nominal?.toString(), "Rp. ")
                      : ""
                  }
                  onChange={(e) => {
                    let value = _.isEmpty(e.target.value?.replace(/[^\d]/g, ""))
                      ? 0
                      : e.target.value?.replace(/[^\d]/g, "");
                    if (parseInt(value) <= parseInt(balance?.ewalletBalance)) {
                      setWithdrawData((prevState) => ({
                        ...prevState,
                        nominal: value,
                      }));
                    } else if (
                      parseInt(value) > parseInt(balance?.ewalletBalance)
                    ) {
                      setWithdrawData((prevState) => ({
                        ...prevState,
                        nominal: balance?.ewalletBalance,
                      }));
                    }
                  }}
                />
                <div className="mt-2 flex items-center justify-between">
                  <div className="text-xs text-gray-400">Saldo Ewallet </div>
                  <div className="flex items-center space-x-1 text-xs font-medium text-gray-600">
                    {loadingBalance ? (
                      <div class="h-3 w-24 animate-pulse rounded bg-gray-200"></div>
                    ) : (
                      <div>
                        {formatRupiah(
                          balance?.ewalletBalance?.toString(),
                          "Rp. ",
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </CardSection>
          )}
          {step === 3 && (
            <CardSection title="Masukkan PIN">
              <p className="mb-3 text-gray-500">
                {"Masukkan PIN Anda. Maksimal 3 (tiga) kali pengulangan."}
              </p>
              <OTPInput
                value={pin}
                name="pin"
                onChange={setPin}
                numInputs={6}
                inputType="tel"
                containerStyle="flex justify-between"
                renderInput={(props) => <input {...props} />}
                inputStyle="otp-input h-12 !w-12 text-center text-xl font-bold text-monochrome-600"
              />
            </CardSection>
          )}
        </div>
      </Container>

      <InformationSheet
        sheetDetail={sheetDetail}
        setSheetDetail={setSheetDetail}
      />
      <div className="fixed bottom-0 w-full">
        <div className="items-normal mx-auto mt-6 flex max-w-screen-xl flex-col space-y-2  p-4 md:items-end">
          <Button
            variant={step === 4 ? "default" : "gradient"}
            label={
              step === 1
                ? "Review Tarik Dana"
                : step === 2
                  ? "Konfirmasi Tarik Dana"
                  : step === 3
                    ? "Konfirmasi Tarik Dana"
                    : "Kembali"
            }
            onClick={() => {
              if (step === 4) {
                navigate("/", { replace: true });
              } else if (step === 3) {
                WithdrawBalance();
              } else {
                setStep(step + 1);
              }
            }}
            disabled={
              !withdrawData.nominal ||
              parseInt(withdrawData.nominal) === 0 ||
              parseInt(withdrawData.nominal) >
                parseInt(balance?.ewalletBalance) ||
              parseInt(balance?.ewalletBalance) === 0
            }
          />
        </div>
      </div>
    </>
  );
};

export default withAuth(Withdraw);
